import { isEmpty } from 'lodash';
import { surveyAPIInstance } from './config';

export const buildRequestOptions = (method, url, { headers = {}, data = {}, params = {} }) => {
    const options = {
        method,
        url,
        headers: {},
    };

    if (!isEmpty(data) || data instanceof FormData) {
        options.data = data;
    }

    if (!isEmpty(params)) {
        options.params = params;
    }

    if (!isEmpty(headers)) {
        Object.keys(headers).forEach((key) => {
            options.headers[key] = headers[key];
        });
    }

    const jwt = window.localStorage.getItem('admin_ui_jwt');
    options.headers.Authorization = `Bearer ${jwt}`;

    return options;
};

export const get = async (path, { params = {} }) => {
    const options = buildRequestOptions('GET', path, { params });

    return surveyAPIInstance.request(options);
};

export const post = async (path, { data = {} }) => {
    const options = buildRequestOptions('POST', path, { data });

    return surveyAPIInstance.request(options);
};

export const put = async (path, { data = {} }) => {
    const options = buildRequestOptions('PUT', path, { data });

    return surveyAPIInstance.request(options);
};

export const patch = async (path, { data = {} }) => {
    const options = buildRequestOptions('PATCH', path, { data });

    return surveyAPIInstance.request(options);
};

export const del = async (path, { params = {} }) => {
    const options = buildRequestOptions('DELETE', path, { params });

    return surveyAPIInstance.request(options);
};
